import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

import './contact.css';

const Contact = () => {
        return (
                <div className="section sectionBackground" id="contact">
                        <div className="viewport">
                                <div className='impressItem'>
                                        <h1>Kontakt</h1>
                                        <p className="sectionLead">
                                                Ich freue mich auf Ihre Nachricht. F&uuml;r Terminw&uuml;nsche oder Fragen erreichen Sie mich telefonisch oder per E&#8209;Mail.
                                        </p>
                                        <table>
                                                <tbody>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                        <Icon className='impressIcon' icon={'mdi:home'} />
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <b>Standort Regensburg</b>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td />
                                                                <td className='impressDetailsCell'>
                                                                        Ziegetsdorfer Str. 32<br />
                                                                        93051 Regensburg
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                        <Icon className='impressIcon' icon={'mdi:home'} />
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <b>Standort Kelheim</b>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td />
                                                                <td className='impressDetailsCell'>
                                                                        Donaustr. 14<br />
                                                                        93309 Kelheim
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                        <Icon className='impressIcon' icon={'mdi:home'} />
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <b>Standort Regensburg</b>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td />
                                                                <td className='impressDetailsCell'>
                                                                        Maximilianstr. 24<br />
                                                                        93047 Regensburg
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                        <Icon className='impressIcon' icon={'mdi:phone'} />
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <a href='tel:+491776962490'>0177 6962490</a>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                        <Icon className='impressIcon' icon={'mdi:at'} />
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <a href='mailto:nloewe66@gmail.com'>nloewe66@gmail.com</a>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <Link to={'/impress'}>Impressum</Link>
                                                                </td>
                                                        </tr>
                                                        <tr>
                                                                <td className='impressIconContainer impressDetailsCell'>
                                                                </td>
                                                                <td className='impressDetailsCell'>
                                                                        <Link to={'/privacy'}>Datenschutzerkl&auml;rung</Link>
                                                                </td>
                                                        </tr>
                                                </tbody>
                                        </table>
                                </div>
                                <div className='impressItem' id='social'>
                                        Folgen Sie mir auf Facebook:<p />
                                        <a href='https://www.facebook.com/hploewe' target='_blank' rel='noopener noreferrer'>
                                                <Icon className='impressSocialIcon' icon={'mdi:facebook'} />
                                        </a>

                                </div>
                        </div>
                </div>
        )
}
export default Contact;